module.exports = __webpack_public_path__ + "static/step-1-838573ecd02be861de672af77f23e095.svg";